// Premium iOS 26 Liquid Glass Theme - $1M+ Software Design
export const theme = {
  light: {
    bg: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    bgSecondary: 'rgba(255, 255, 255, 0.6)',
    text: '#0f172a',
    textSecondary: 'rgba(15, 23, 42, 0.7)',
    textMuted: 'rgba(15, 23, 42, 0.5)',
    border: 'rgba(59, 130, 246, 0.15)',
    cardBg: 'rgba(255, 255, 255, 0.6)',
    glass: {
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 20%, rgba(255, 255, 255, 0.02) 50%, rgba(255, 255, 255, 0.05) 80%, rgba(255, 255, 255, 0.1) 100%)',
      backdropFilter: 'blur(40px) saturate(150%)',
      WebkitBackdropFilter: 'blur(40px) saturate(150%)',
      border: '1px solid rgba(59, 130, 246, 0.15)',
      borderRadius: '24px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.2), inset 0 -1px 0 rgba(255, 255, 255, 0.05), 0 0 80px rgba(59, 130, 246, 0.1)'
    }
  },
  dark: {
    bg: '#000000',
    bgImage: `
      radial-gradient(ellipse 80% 50% at 50% -20%, rgba(59, 130, 246, 0.15), transparent),
      radial-gradient(ellipse 60% 40% at 100% 100%, rgba(59, 130, 246, 0.1), transparent),
      radial-gradient(ellipse 40% 60% at 0% 100%, rgba(99, 102, 241, 0.08), transparent)
    `,
    bgSecondary: 'rgba(255, 255, 255, 0.03)',
    text: '#ffffff',
    textSecondary: 'rgba(255, 255, 255, 0.6)',
    textMuted: 'rgba(255, 255, 255, 0.4)',
    border: 'rgba(255, 255, 255, 0.15)',
    cardBg: 'rgba(255, 255, 255, 0.03)',
    glass: {
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 20%, rgba(255, 255, 255, 0.02) 50%, rgba(255, 255, 255, 0.05) 80%, rgba(255, 255, 255, 0.1) 100%)',
      backdropFilter: 'blur(40px) saturate(150%)',
      WebkitBackdropFilter: 'blur(40px) saturate(150%)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      borderRadius: '24px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.2), inset 0 -1px 0 rgba(255, 255, 255, 0.05), 0 0 80px rgba(59, 130, 246, 0.1)'
    },
    glassHover: {
      borderColor: 'rgba(59, 130, 246, 0.3)',
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(59, 130, 246, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.25), inset 0 -1px 0 rgba(255, 255, 255, 0.05), 0 0 100px rgba(59, 130, 246, 0.2)'
    }
  }
};

// Professional Color System - iOS 26 Style
export const colors = {
  primary: '#3b82f6',
  secondary: '#2563eb',
  accent: '#3b82f6',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  primaryGlow: 'rgba(59, 130, 246, 0.3)',
  primaryGlowStrong: 'rgba(59, 130, 246, 0.6)',
  blue: {
    50: 'rgba(59, 130, 246, 0.05)',
    100: 'rgba(59, 130, 246, 0.1)',
    200: 'rgba(59, 130, 246, 0.2)',
    300: 'rgba(59, 130, 246, 0.3)',
    400: 'rgba(59, 130, 246, 0.4)',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8'
  },
  gradient: {
    primary: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    vibrant: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 50%, #93c5fd 100%)',
    success: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    warning: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    error: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
  }
};

